import * as Yup from 'yup'
import { cmsExpertCollectionsWidgetItemValidationSchema } from './ExpertCollectionsItem'

export const exportCollectionsSchemaValidation = Yup.object().shape({
  content: Yup.object({
    cmsExpertCollectionsWidgetItems:
      cmsExpertCollectionsWidgetItemValidationSchema.required(),
  }),
})
